import { render, staticRenderFns } from "./screenshotTwo.vue?vue&type=template&id=26e1247c&"
import script from "./screenshotTwo.vue?vue&type=script&lang=js&"
export * from "./screenshotTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports